var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"sctTabs_wrapper\">\n<ul class=\"sctTabs_tabs\">\n<li ng-repeat=\"tab in vm.settings.tabs\">\n<a ng-click=\"vm.settings.callback(tab)\" ng-class=\"{ active: tab.id === vm.settings.activeTab.id }\">\n{{ ::tab.label }}\n<span class=\"sctTabs_count\" ng-if=\"tab.count() > 0\">\n({{ tab.count() }})\n</span>\n</a>\n</li>\n</ul>\n</div>";
var id1="sct/sctTabs/sctTabs.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/sct/sctTabs/sctTabs.html
// module id = 1298
// module chunks = 1